export default "__VITE_ASSET__BjSrcqBm__"